module.exports = __webpack_public_path__ + "img/k3s-black.d52e5687.svg";